export const getCurrentLocationQueryParams = () => {
  return new URLSearchParams(window.location.search);
}

export const getCurrentLocationQueryParam = (name) => {
  const queryParams = getCurrentLocationQueryParams();
  return queryParams.get(name);
}
